import {
  ISectionLabelText,
} from "apps/website/components/section/SectionLabelText/SectionLabelText";

export const data = {
  title: "cats are carnivores. so why does cat food have so little meat?",
  subtitle: "",
  labelText: {
    labelPrefix: "A leading cat food label:",
    label: "INGREDIENTS:  meat by-products, poultry by-products, chicken, natural flavour, sodium, tripolyphosphate, dried yam, carrageean, minerals & vitamins, colour, xanthan gum, dL-methionine, taurine, sodium nitrite (for colour retention) sufficient water for processing",
    labelSuffix: "Confused as to what's really in that cat food? We were too. Here's what we discovered.",
  } as ISectionLabelText,
  imageMobile: {
    width: 342,
    height: 371,
    src: "https://a.storyblok.com/f/176726/342x371/779b78401f/commercial-cat-food-image-mobile2.png",
    alt: "Commercial cat food",
  },
  imageDesktop: {
    src: "https://a.storyblok.com/f/176726/927x584/f656d34c5c/commercial-cat-food-image2.png",
    width: 926,
    height: 583,
    alt: "Commercial cat food",
  },
};
